import styled from "@emotion/styled";
import { Table } from "antd";

export const StyledTable = styled(Table)`
  &.rowHover .ant-table-row:hover {
    cursor: pointer;
  }

  .ant-menu {
    color: ${({ theme }) => theme.palette.text.primary} !important;
    background: ${({ theme }) => theme.palette.custom.white} !important;
  }

  &.custom-table {
    .ant-table-cell:last-child {
      padding-right: 20px !important;
    }

    .ant-table-thead {
      border-bottom: 1px solid black;
    }

    .ant-table-thead > tr > th {
      background-color: ${({ theme }) => theme.palette.custom.white} !important;
    }

    .ant-table-thead > tr > th {
      background-color: ${({ theme }) => theme.palette.custom.white};
      color: ${({ theme }) => theme.palette.text.primary};
      text-transform: uppercase;
      font-weight: 500 !important;
    }

    .ant-table-container table > thead > tr:first-of-type th:first-of-type,
    .ant-table-container table > thead > tr:first-of-type th:last-child {
      border-radius: 0;
    }
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #97979761;
    color: ${({ theme }) => theme.palette.text.primary} !important;
  }

  .ant-checkbox-inner {
    border-radius: 0px;
  }

  /* .accounting tr.ant-table-row-level-0 p {
    font-weight: bold !important;
  } */

  /* .accounting td {
    padding: 0px 0px 0px 4px !important;
  }

  .accounting thead.ant-table-thead {
    padding: 10px;
  }

  .accounting .ant-table-row-level-0 td {
    padding-left: 10px !important;
  }

  .accounting .ant-table-thead th {
    font-size: 20px;
  } */

  //mini option
  .ant-pagination-mini .ant-pagination-item,
  .ant-pagination-mini .ant-pagination-prev,
  .ant-pagination-mini .ant-pagination-next,
  .ant-pagination-mini .ant-pagination-options-size-changer,
  .ant-pagination-mini .ant-select-selector {
    min-width: 32px;
    line-height: 30px;
    height: 32px !important;
  }
  .ant-pagination-mini .ant-select-single .ant-select-selection-item {
    height: 32px !important;
    line-height: 30px !important;
  }

  .ant-pagination-mini .ant-pagination-item {
    margin: 0px 2px;
  }

  .ant-pagination-mini .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-mini .ant-pagination-next .ant-pagination-item-link,
  .ant-pagination-mini .ant-pagination-item:not(.ant-pagination-item-active) {
    border-color: #d9d9d9;
    background-color: ${({ theme }) => theme.palette.custom.white};
  }

  .ant-pagination-item-active {
    border-color: ${({ theme }) => theme.palette.primary.main};

    a {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }

  .custom-bilan {
    margin-bottom: 20px;

    .ant-table-thead > tr > th {
      background-color: ${({ theme }) => theme.palette.custom.white} !important;
      color: ${({ theme }) => theme.palette.text.primary};
      font-weight: 500 !important;
      text-transform: uppercase;
    }
    .ant-table-thead > tr > th {
      padding: 8px 16px !important;
    }
    .ant-table-tbody > tr > td {
      padding: 4px 16px !important;
    }

    .ant-table-tbody > tr > td {
      border-bottom: 1px solid #97979761;
    }

    .ant-table-container table > thead > tr:first-of-type th:first-of-type,
    .ant-table-container table > thead > tr:first-of-type th:last-child {
      border-radius: 0;
    }

    .strong {
      font-weight: bold;
    }
  }

  .ant-table {
    .ant-form-item .ant-input-number {
      height: 32px !important;
      border-radius: 0px !important;
      border: 1px solid #adadad !important;
    }

    .ant-form-item * {
      height: 32px !important;
      line-height: 32px !important;
    }

    .ant-form-item .ant-select .ant-select-selector {
      height: 32px !important;
      line-height: 32px !important;
    }

    .ant-select-arrow {
      top: 24%;
    }

    .ant-input-number {
      height: 32px !important;
      line-height: 32px !important;
    }
  }

  table tr th.ant-table-selection-column,
  table tr td.ant-table-selection-column {
    width: 50px !important;
    padding: 0 16px !important;
  }
`;
